import { Injectable } from '@angular/core';
import { MountingCardViewOptions } from '@app/modules/mounting/models';
import { Query } from '@datorama/akita';
import { ApprovalReportSelectionState, UiState } from './ui-state.model';
import { UiStateStore } from './ui-state.store';
import { StorageKey, StorageService } from 'chronos-shared';

@Injectable({ providedIn: 'root' })
export class UiStateQuery extends Query<UiState> {
  constructor(protected uiStateStore: UiStateStore, private storageService: StorageService) {
    super(uiStateStore);
  }

  public getShiftReportStateSelectedShift(): number {
    return this.getValue().shiftReportSelectedShiftId;
  }

  public getApprovalReportStateSelectionState(): ApprovalReportSelectionState | null {
    const sessionValue = this.getValue().approvalReportSelectionState;
    if (sessionValue) {
      return sessionValue;
    }
    const localStorageValue = this.storageService.getItem(StorageKey.approvalReportSelectionState);
    if (localStorageValue) {
      return JSON.parse(localStorageValue);
    }
    return null;
  }

  public getMountingSelectedRoute(): string {
    return this.getValue().mountingSelectedRoute;
  }

  public getMountingOrderId(): number {
    return this.getValue().mountingSelectedOrderId;
  }

  public getMountingPrimaryListView(): MountingCardViewOptions {
    return this.getValue().mountingPrimaryListview;
  }

  public getMountingSecondaryExpandedArticles(): number[] {
    return this.getValue().mountingSecondaryExpandedArticles;
  }

  public getMountingSecondaryMountedExpandedArticles(): number[] {
    return this.getValue().mountingSecondaryMountedExpandedArticles;
  }

  public getMountingTraceExpandedArticles(): number[] {
    return this.getValue().mountingTraceExpandedArticles;
  }

  public getOrderListExpandedOrders(): number[] {
    return this.getValue().orderListExpandedOrders;
  }

  public getOrderListExpandedOrder(productionOrderId: number): boolean {
    return this.getValue().orderListExpandedOrders.find((x) => x === productionOrderId) === undefined;
  }

  public getDocumentSelectedRoute(): string {
    return this.getValue().documentSelectedRoute;
  }

  public getDocumentOrderId(): number {
    return this.getValue().documentSelectedOrderId;
  }

  public getRunPhaseProducedMaterialExpanded(producedMaterialId: number): boolean {
    return this.getValue().runPhaseExpandedProducedMaterials.find((x) => x === producedMaterialId) === producedMaterialId;
  }
}
